import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { CheckCircle2, AlertTriangle } from 'lucide-react';
export const ProductTomos = () => {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — El Arsenal Sin Materiales',
    desc: 'Juegos y actividades sin necesitar nada del depósito. Para cuando llegás al patio con las manos vacías.',
    color: 'bg-blue-600',
    label: 'Sin Materiales'
  }, {
    icon: '📗',
    title: 'Tomo 2 — Entrada en Calor Dinámica',
    desc: '20 activaciones de 10 minutos listas para usar. Para que el grupo arranque con energía desde el minuto 1.',
    color: 'bg-green-600',
    label: 'Entrada en Calor'
  }, {
    icon: '📙',
    title: 'Tomo 3 — Juegos en Equipo',
    desc: '20 dinámicas de cooperación y competencia. Para que el grupo trabaje junto sin que vos tengas que mediar todo.',
    color: 'bg-orange-500',
    label: 'Juegos en Equipo'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Coordinación y Motricidad',
    desc: '20 sesiones de equilibrio, agilidad y control corporal. Para desarrollar habilidades motrices reales con juegos que enganchan.',
    color: 'bg-red-600',
    label: 'Coordinación'
  }, {
    icon: '📓',
    title: 'Tomo 5 — Resistencia y Actividad Física',
    desc: '20 juegos de alta intensidad listos para usar. Para las clases donde el grupo necesita moverse de verdad.',
    color: 'bg-purple-600',
    label: 'Resistencia'
  }, {
    icon: '📔',
    title: 'Tomo 6 — Clases Completas Listas',
    desc: '20 clases de 40 minutos con inicio, desarrollo y cierre. Para el domingo a la noche cuando necesitás todo resuelto.',
    color: 'bg-yellow-600',
    label: 'Clases Listas'
  }];
  const features = ['Estructura de clase completa lista para ejecutar', 'Consignas palabra por palabra (sin improvisar)', 'Progresión de dificultad en cada actividad', 'Variantes para espacio chico y grupos grandes', 'Adaptaciones para días de lluvia', '100% sin materiales deportivos obligatorios', 'Funciona para primaria y secundaria', 'Apto para cualquier guía o instructor de Ed. Física'];
  const featureChips = ['✅ Primaria + Secundaria', '✅ Planificación anual lista', '✅ Consignas palabra por palabra', '✅ Adaptaciones para lluvia y espacios chicos', '✅ Sin materiales obligatorios', '✅ 120+ actividades listas para usar'];
  return <Section className="bg-slate-200/70" data-id="element-19">
      <FadeIn className="text-center mb-12" data-id="element-20">
        <h2 className="text-3xl md:text-5xl font-bold text-navy mb-4" data-id="element-21">
          🏆 EL ARSENAL DEL PROFE™
        </h2>
        <p className="text-xl text-gray-600 font-medium" data-id="element-22">
          6 Tomos + 6 Bonos — Primaria + Secundaria
          <br data-id="element-23" />
          120+ Actividades — Todo resuelto.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} className="mb-6" data-id="element-24">
        <div className="flex justify-center gap-3 md:gap-5 px-2 md:px-0" data-id="element-25">
          {tomos.map((tomo, i) => <div key={i} className={`${tomo.color} w-[52px] md:w-36 h-[80px] md:h-52 rounded-lg md:rounded-xl shadow-lg flex flex-col items-center justify-end p-1.5 md:p-4 text-center text-white relative overflow-hidden transform hover:-translate-y-2 transition-transform border border-white/20`} data-id="element-26">
              <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent h-1/3" data-id="element-27"></div>
              <span className="font-bold text-white text-[8px] md:text-sm leading-tight drop-shadow-md" data-id="element-28">
                {tomo.label}
              </span>
            </div>)}
        </div>
        <div className="text-center mt-4" data-id="element-29">
          <span className="inline-block bg-navy text-white text-xs md:text-sm font-bold px-4 py-1.5 rounded-full" data-id="element-30">
            6 TOMOS COMPLETOS
          </span>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} className="mb-12" data-id="element-31">
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 max-w-3xl mx-auto" data-id="element-32">
          {featureChips.map((chip, i) => <span key={i} className="bg-navy/10 text-navy border border-navy/20 shadow-sm px-3 py-1.5 rounded-full text-xs md:text-sm font-medium" data-id="element-33">
              {chip}
            </span>)}
        </div>
      </FadeIn>

      <FadeIn className="text-center mb-10" data-id="element-34">
        <h3 className="text-2xl md:text-3xl font-bold text-navy" data-id="element-35">
          LO QUE RECIBÍS...
        </h3>
      </FadeIn>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-36">
        {tomos.map((tomo, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-37">
            <div className="bg-white rounded-2xl p-6 border border-slate-200 h-full hover:shadow-xl hover:shadow-slate-200/50 transition-all" data-id="element-38">
              <div className="text-4xl mb-4" data-id="element-39">{tomo.icon}</div>
              <h3 className="text-xl font-bold text-navy mb-3" data-id="element-40">{tomo.title}</h3>
              <p className="text-gray-600" data-id="element-41">{tomo.desc}</p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} data-id="element-42">
        <div className="bg-white rounded-3xl p-8 md:p-12 border border-slate-200 shadow-sm max-w-4xl mx-auto" data-id="element-43">
          <h3 className="text-2xl font-bold text-navy mb-8 text-center" data-id="element-44">
            Cada tomo incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-45">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-46">
                <CheckCircle2 className="text-green-500 shrink-0 mt-1" size={20} data-id="element-47" />
                <span className="text-gray-600 font-medium" data-id="element-48">{feature}</span>
              </div>)}
          </div>

          <div className="rounded-2xl px-6 py-5 md:px-8 md:py-6 mt-8 text-center max-w-2xl mx-auto space-y-2 bg-[#E2E8F0FA]" data-id="element-49">
            <p className="font-medium text-lg text-[#4E4949] bg-[#00000000]" data-id="element-50">
              Abrís el tomo que quieras trabajar, leés 2 minutos y tenés la
              clase totalmente lista para usar.
            </p>
            <p className="font-bold text-xl text-[#F97516]" data-id="element-51">
              Así de simple... ya no tenés que perder más tiempo.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    title: '🎁 El Calendario Antiestrés',
    desc: 'Planificación anual lista para copiar y pegar. 12 meses de clases organizadas en una sola mirada.',
    value: '$8.000'
  }, {
    num: '02',
    title: '🎁 Banco de Frases GAP',
    desc: '120 consignas palabra por palabra para controlar el patio. Decís la frase. El grupo arranca. Sin gritar.',
    value: '$9.000'
  }, {
    num: '03',
    title: '🎁 Evaluación Flash Sin Estrés',
    desc: 'Rúbricas y registros en 1 hoja para primaria y secundaria. Sin cortar el juego. Sin llevarte trabajo a casa.',
    value: '$8.000'
  }, {
    num: '04',
    title: '🎁 Kit Día de Lluvia',
    desc: '25 soluciones para no perder la clase cuando no hay patio. Aula, pasillo o SUM: igual tenés clase completa.',
    value: '$9.000'
  }, {
    num: '05',
    title: '🎁 Espacios Chicos',
    desc: '25 actividades para patios mínimos y grupos grandes. Menos espacio no es excusa. Es un desafío resuelto.',
    value: '$8.000'
  }, {
    num: '06',
    title: '🎁 Juegos Rápidos 5 Minutos',
    desc: '30 micro-juegos de emergencia listos para usar. Tenés 5 minutos. Arrancás en 15 segundos.',
    value: '$9.000'
  }];
  return <Section className="bg-navy text-white" data-id="element-52">
      <FadeIn className="text-center mb-16" data-id="element-53">
        <h2 className="text-3xl md:text-5xl font-bold text-brandOrange mb-4 flex items-center justify-center gap-4" data-id="element-54">
          Además te llevás 6 bonos estratégicos
        </h2>
        <p className="text-lg md:text-xl font-medium text-gray-300" data-id="element-55">
          Incluidos en todas las ofertas — sin costo extra
        </p>
      </FadeIn>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-56">
        {bonuses.map((bono, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-57">
            <div className="bg-white/10 rounded-2xl p-6 border border-white/20 h-full relative overflow-hidden group hover:bg-white/15 transition-colors" data-id="element-58">
              <div className="absolute -right-4 -top-4 text-6xl font-black text-white/5 group-hover:text-white/10 transition-colors" data-id="element-59">
                {bono.num}
              </div>
              <div className="text-brandOrange font-bold mb-2" data-id="element-60">
                BONO {bono.num}
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-61">{bono.title}</h3>
              <p className="text-gray-300 mb-6 text-sm" data-id="element-62">{bono.desc}</p>
              <div className="mt-auto pt-4 border-t border-white/10 flex items-center justify-between" data-id="element-63">
                <span className="text-gray-400 line-through text-sm" data-id="element-64">
                  Valor: {bono.value}
                </span>
                <span className="bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-65">
                  GRATIS
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="text-center bg-white/5 py-8 px-6 rounded-2xl border border-white/10 max-w-2xl mx-auto mb-10" data-id="element-66">
        <p className="text-xl text-gray-300 mb-2" data-id="element-67">Valor total de los 6 Bonos</p>
        <p className="md:text-5xl font-black text-gray-500 line-through mb-3 text-[32px]" data-id="element-68">
          $51.000
        </p>
        <p className="text-3xl md:text-4xl font-bold text-brandOrange mb-1" data-id="element-69">
          🎁 GRATIS — Solo con tu MegaPack
        </p>
        <p className="text-sm text-gray-400 mb-6" data-id="element-70">
          Incluidos en las ofertas. Siempre.
        </p>
        <a href="#pricing" className="inline-flex items-center justify-center gap-2 font-bold rounded-full px-10 py-4 text-lg md:text-xl bg-brandOrange hover:bg-brandOrange-hover text-white transition-all duration-300 transform hover:scale-105 animate-glow-button" data-id="element-71">
          QUIERO MI MEGAPACK AHORA →
        </a>
      </FadeIn>
    </Section>;
};
export const UrgencyCounter = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="animate-red-pulse-bg border-t border-red-500/20 py-12" data-id="element-72">
      <FadeIn className="max-w-3xl mx-auto text-center space-y-6" data-id="element-73">
        <h3 className="text-2xl font-bold text-red-100" data-id="element-74">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h3>
        <div className="flex justify-center gap-4 text-white" data-id="element-75">
          <div className="bg-red-900/50 border border-red-500/30 rounded-xl p-4 min-w-[80px] animate-red-glow" data-id="element-76">
            <div className="text-4xl font-black text-white" data-id="element-77">
              {hours.toString().padStart(2, '0')}
            </div>
            <div className="text-xs text-red-300 mt-1 uppercase" data-id="element-78">hs</div>
          </div>
          <div className="text-4xl font-black py-4 text-red-500" data-id="element-79">:</div>
          <div className="bg-red-900/50 border border-red-500/30 rounded-xl p-4 min-w-[80px] animate-red-glow" data-id="element-80">
            <div className="text-4xl font-black text-white" data-id="element-81">
              {minutes.toString().padStart(2, '0')}
            </div>
            <div className="text-xs text-red-300 mt-1 uppercase" data-id="element-82">min</div>
          </div>
          <div className="text-4xl font-black py-4 text-red-500" data-id="element-83">:</div>
          <div className="bg-red-900/50 border border-red-500/30 rounded-xl p-4 min-w-[80px] animate-red-glow" data-id="element-84">
            <div className="text-4xl font-black text-brandOrange" data-id="element-85">
              {seconds.toString().padStart(2, '0')}
            </div>
            <div className="text-xs text-red-300 mt-1 uppercase" data-id="element-86">seg</div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 text-yellow-400 font-medium" data-id="element-87">
          <AlertTriangle size={20} data-id="element-88" />
          <span data-id="element-89">Después sube $15.000 ARS. No vuelve.</span>
        </div>

        <div className="bg-red-900/30 p-6 rounded-2xl border border-red-500/20 mt-8" data-id="element-90">
          <div className="flex justify-between text-sm text-red-200 mb-2 font-medium" data-id="element-91">
            <span className="flex items-center gap-2" data-id="element-92">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-93"></span>{' '}
              Cupos al precio de lanzamiento
            </span>
            <span data-id="element-94">Quedan pocos</span>
          </div>
          <div className="w-full bg-red-950 rounded-full h-3 mb-2 overflow-hidden border border-red-900" data-id="element-95">
            <div className="bg-gradient-to-r from-brandOrange to-red-500 h-full rounded-full" style={{
            width: '71%'
          }} data-id="element-96"></div>
          </div>
          <p className="text-xs text-red-300 text-right" data-id="element-97">
            71% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const Pricing = () => {
  const [selected, setSelected] = useState<'plus' | 'basic'>('plus');
  const checkoutUrl = selected === 'plus' ? 'https://centershop.store/cart/47907900162293:1' : 'https://centershop.store/cart/47907894886645:1';
  const ctaText = selected === 'plus' ? 'SÍ, QUIERO EL ARSENAL + POTENCIADOR →' : 'SÍ, QUIERO MI ARSENAL AHORA →';
  return <Section className="bg-[#1a1a2e]" id="pricing" data-id="element-98">
      <FadeIn className="text-center mb-8" data-id="element-99">
        <h2 className="text-3xl md:text-5xl font-black text-white" data-id="element-100">
          Elegí tu <span className="text-brandOrange" data-id="element-101">ARSENAL:</span>
        </h2>
        <p className="text-gray-400 mt-3" data-id="element-102">
          Todas las opciones incluyen los 6 bonos estratégicos
        </p>
      </FadeIn>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-103">
        {/* Option Plus - MÁS ELEGIDO (first) */}
        <FadeIn delay={0.1} data-id="element-104">
          <button onClick={() => setSelected('plus')} className={`w-full text-left rounded-2xl p-5 md:p-6 transition-all duration-300 border-2 ${selected === 'plus' ? 'bg-[#1e2a3a] border-brandOrange shadow-lg shadow-brandOrange/20' : 'bg-[#1e2a3a]/50 border-gray-700 hover:border-gray-500'}`} data-id="element-105">
            <div className="flex items-start gap-4" data-id="element-106">
              <div className={`w-6 h-6 rounded-full border-2 mt-1 shrink-0 flex items-center justify-center ${selected === 'plus' ? 'border-brandOrange' : 'border-gray-500'}`} data-id="element-107">
                {selected === 'plus' && <div className="w-3 h-3 rounded-full bg-brandOrange" data-id="element-108"></div>}
              </div>
              <div className="flex-grow" data-id="element-109">
                <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-110">
                  <span className="text-lg" data-id="element-111">🏆</span>
                  <h3 className="text-lg md:text-xl font-black text-white" data-id="element-112">
                    ARSENAL + POTENCIADOR
                  </h3>
                </div>
                <div className="flex flex-wrap gap-2 mb-2" data-id="element-113">
                  <span className="bg-brandOrange text-white text-xs font-bold px-2.5 py-0.5 rounded-full" data-id="element-114">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="bg-green-600 text-white text-xs font-bold px-2.5 py-0.5 rounded-full" data-id="element-115">
                    AHORRÁS $7.990
                  </span>
                </div>
                <p className="text-gray-400 text-sm" data-id="element-116">
                  6 Tomos + 6 Bonos + 3 Volúmenes del Potenciador
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-117">
                <p className="text-gray-500 line-through text-sm" data-id="element-118">$67.990</p>
                <p className={`text-3xl md:text-4xl font-black ${selected === 'plus' ? 'text-brandOrange' : 'text-white'}`} data-id="element-119">
                  $27.990
                </p>
              </div>
            </div>
          </button>
        </FadeIn>

        {/* Option Basic */}
        <FadeIn delay={0.2} data-id="element-120">
          <button onClick={() => setSelected('basic')} className={`w-full text-left rounded-2xl p-5 md:p-6 transition-all duration-300 border-2 ${selected === 'basic' ? 'bg-[#1e2a3a] border-brandOrange shadow-lg shadow-brandOrange/20' : 'bg-[#1e2a3a]/50 border-gray-700 hover:border-gray-500'}`} data-id="element-121">
            <div className="flex items-start gap-4" data-id="element-122">
              <div className={`w-6 h-6 rounded-full border-2 mt-1 shrink-0 flex items-center justify-center ${selected === 'basic' ? 'border-brandOrange' : 'border-gray-500'}`} data-id="element-123">
                {selected === 'basic' && <div className="w-3 h-3 rounded-full bg-brandOrange" data-id="element-124"></div>}
              </div>
              <div className="flex-grow" data-id="element-125">
                <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-126">
                  <span className="text-lg" data-id="element-127">📘</span>
                  <h3 className="text-lg md:text-xl font-black text-white" data-id="element-128">
                    EL ARSENAL DEL PROFE
                  </h3>
                </div>
                <p className="text-gray-400 text-sm" data-id="element-129">6 Tomos + 6 Bonos</p>
              </div>
              <div className="text-right shrink-0" data-id="element-130">
                <p className="text-gray-500 line-through text-sm" data-id="element-131">$49.990</p>
                <p className={`text-3xl md:text-4xl font-black ${selected === 'basic' ? 'text-brandOrange' : 'text-white'}`} data-id="element-132">
                  $19.990
                </p>
              </div>
            </div>
          </button>
        </FadeIn>

        {/* Single CTA */}
        <FadeIn delay={0.3} data-id="element-133">
          <CTAButton href={checkoutUrl} fullWidth className="text-lg md:text-xl py-5 mt-6" data-id="element-134">
            {ctaText}
          </CTAButton>
          <div className="flex flex-wrap justify-center gap-4 mt-4 text-xs text-gray-500 font-medium" data-id="element-135">
            <span data-id="element-136">🔒 Pago 100% seguro</span>
            <span data-id="element-137">⚡ Acceso en 5 minutos</span>
            <span data-id="element-138">🛡️ Garantía 30 días</span>
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const Potenciador = () => {
  const comparisons = [{
    bad: 'Sacás las pelotas y el grupo se dispersa en 30 segundos',
    good: '20 sesiones técnicas con pelota, conos y pecheras. Todos participan.'
  }, {
    bad: 'Los conos están en el depósito pero no sabés cómo usarlos bien',
    good: 'Circuitos de velocidad y táctica que el grupo pide repetir.'
  }, {
    bad: 'Querés dar clases de preparación física pero no sabés estructurarlas',
    good: '20 sesiones atléticas con sogas, colchonetas y bastones listas.'
  }, {
    bad: 'Tus alumnos de secundaria se aburren o no participan',
    good: 'Inteligencia motriz con aros y tortuguitas: piensan mientras se mueven.'
  }];
  const volumes = [{
    icon: '📕',
    title: 'Volumen 1 — Táctica y Precisión',
    materials: 'Pelotas + Conos + Pecheras',
    desc: '20 sesiones técnicas y tácticas para secundaria'
  }, {
    icon: '📗',
    title: 'Volumen 2 — Rendimiento Atlético',
    materials: 'Sogas + Colchonetas + Bastones',
    desc: '20 sesiones de preparación física real'
  }, {
    icon: '📘',
    title: 'Volumen 3 — Lógica y Destreza',
    materials: 'Aros + Tortuguitas + Materiales Mixtos',
    desc: '20 sesiones de inteligencia motriz avanzada'
  }];
  return <Section className="bg-slate-200/80" data-id="element-139">
      <FadeIn className="text-center max-w-3xl mx-auto mb-16" data-id="element-140">
        <h2 className="text-3xl md:text-5xl font-bold text-navy mb-6" data-id="element-141">
          🕊️ ¿QUÉ AGREGA EL POTENCIADOR DE CLASES?
        </h2>
        <p className="text-lg text-gray-600" data-id="element-142">
          El Arsenal del Profe resuelve el problema del profe que llega sin nada
          preparado. El Potenciador lleva ese sistema al siguiente nivel:{' '}
          <strong className="text-navy" data-id="element-143">
            clases con materiales deportivos que se sienten como un
            entrenamiento de club profesional.
          </strong>
        </p>
      </FadeIn>

      <div className="max-w-4xl mx-auto mb-16" data-id="element-144">
        <div className="bg-white rounded-3xl overflow-hidden border border-slate-200 shadow-sm" data-id="element-145">
          <div className="grid grid-cols-2 bg-slate-100 p-4 font-bold text-center text-sm md:text-base" data-id="element-146">
            <div className="text-slate-500" data-id="element-147">❌ Sin Potenciador</div>
            <div className="text-green-600" data-id="element-148">✅ Con Potenciador</div>
          </div>
          <div className="divide-y divide-slate-100" data-id="element-149">
            {comparisons.map((row, i) => <div key={i} className="grid grid-cols-2 p-4 md:p-6 gap-4 text-sm md:text-base" data-id="element-150">
                <div className="text-slate-600 pr-4" data-id="element-151">{row.bad}</div>
                <div className="text-navy font-medium pl-4 border-l border-slate-100" data-id="element-152">
                  {row.good}
                </div>
              </div>)}
          </div>
        </div>
      </div>

      <FadeIn delay={0.2} className="max-w-5xl mx-auto" data-id="element-153">
        <h3 className="text-2xl font-bold text-center text-navy mb-8" data-id="element-154">
          ✅ EL POTENCIADOR INCLUYE:
        </h3>
        <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-155">
          {volumes.map((vol, i) => <div key={i} className="bg-white border-2 border-slate-100 rounded-2xl p-6 shadow-sm hover:border-brandOrange hover:shadow-md transition-all" data-id="element-156">
              <div className="text-4xl mb-4" data-id="element-157">{vol.icon}</div>
              <h4 className="font-bold text-lg text-navy mb-1" data-id="element-158">{vol.title}</h4>
              <p className="text-sm font-semibold text-brandOrange mb-3" data-id="element-159">
                {vol.materials}
              </p>
              <p className="text-gray-600 text-sm" data-id="element-160">{vol.desc}</p>
            </div>)}
        </div>

        <div className="bg-navy text-white rounded-2xl p-6 text-center" data-id="element-161">
          <p className="text-xl font-bold mb-2" data-id="element-162">
            Total: 60 sesiones adicionales de alto nivel
          </p>
          <p className="text-gray-300" data-id="element-163">
            Para el profe de secundaria que no se conforma con lo básico.
          </p>
        </div>
      </FadeIn>
    </Section>;
};